"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _state = _interopRequireDefault(require("@/libs/state"));
var _TextFormatting = require("@/helpers/TextFormatting");
var _MessageInfo = _interopRequireDefault(require("./MessageInfo"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _MediaViewer = _interopRequireDefault(require("./MediaViewer"));
// eslint-plugin-vue's max-len rule reads the entire file, including the CSS. so we can't use this
// here as some of the rules cannot be broken up any smaller
/* eslint-disable max-len */

var methods = {
  props: {},
  getAvatar: function getAvatar(nick) {
    var _getState$getActiveNe;
    if (!nick) {
      return null;
    }
    return (_getState$getActiveNe = (0, _state.default)().getActiveNetwork().users[nick.toUpperCase()]) === null || _getState$getActiveNe === void 0 ? void 0 : _getState$getActiveNe.avatar;
  },
  parseUserRealname: function parseUserRealname(realname) {
    // Regex: (Gender)(Age)(City)_any
    // Gender: M, F, U
    // Age: 2 digits or UU
    // City: 2 letters or UU (e.g. MI, FR, UU)
    var match = (typeof realname === 'string' ? realname : '').match(/^([MFNU])(\d{2}|UU)([A-Z]{2}|UU)_/);
    if (match) {
      return {
        gender: match[1] === 'U' ? null : match[1],
        // Will be 'M', 'F', or 'U'
        age: match[2] === 'UU' ? null : parseInt(match[2], 10),
        // null if 'UU', otherwise number
        city: match[3] === 'UU' ? null : match[3] // null if 'UU', otherwise city code
      };
    }

    return null; // Realname doesn't match the expected format
  },
  getGender: function getGender(realname) {
    var parsed = this.parseUserRealname(realname);
    if (parsed) {
      switch (parsed.gender) {
        case 'M':
          return 'Uomo';
        case 'F':
          return 'Donna';
        case 'N':
          return 'Non binario';
        default:
          return null;
      }
    }
    return null;
  },
  getAge: function getAge(realname) {
    var parsed = this.parseUserRealname(realname);
    if (parsed) {
      return parsed.age ? parsed.age : null;
    }
    return null;
  },
  getProvince: function getProvince(realname) {
    var parsed = this.parseUserRealname(realname);
    if (parsed) {
      return parsed.city ? parsed.city : null;
    }
    return null;
  },
  hasActiveStory: function hasActiveStory(nick) {
    // Check if user has an active story using global helper
    if (typeof window !== 'undefined' && window.hasActiveStory) {
      return window.hasActiveStory(nick);
    }
    return false;
  },
  showRealName: function showRealName() {
    var props = this.props;

    // Showing realname is not enabled
    if (!props.ml.buffer.setting('show_realnames')) {
      return false;
    }

    // Server does not support extended-join so realname would be inconsistent
    var client = props.ml.buffer.getNetwork().ircClient;
    if (!client.network.cap.isEnabled('extended-join')) {
      return false;
    }

    // We dont have a user or users realname
    if (!props.message.user || !props.message.user.realname) {
      return false;
    }

    // No point showing the realname if it's the same as the nick
    if (props.message.user.nick.toLowerCase() === props.message.user.realname.toLowerCase()) {
      return false;
    }

    // If the realname contains a URL it's most likely a clients website
    if (_TextFormatting.urlRegex.test(props.message.user.realname)) {
      return false;
    }
    return true;
  },
  getNetwork: function getNetwork() {
    var props = this.props;
    return props.ml.buffer.getNetwork();
  },
  isRepeat: function isRepeat() {
    var props = this.props;
    var ml = props.ml;
    var idx = props.idx;
    var message = props.message;
    var prevMessage = ml.filteredMessages[idx - 1];
    return !!prevMessage && prevMessage.nick === message.nick && message.time - prevMessage.time < 60000 && prevMessage.type !== 'traffic' && message.type !== 'traffic' && message.type === prevMessage.type && message.day_num === prevMessage.day_num;
  },
  isHoveringOverMessage: function isHoveringOverMessage(message) {
    var props = this.props;
    return message.nick && message.nick.toLowerCase() === props.ml.hover_nick.toLowerCase();
  },
  isMessage: function isMessage(message) {
    var types = ['privmsg', 'action', 'notice', 'message'];
    return types.indexOf(message.type) > -1;
  },
  displayAvatar: function displayAvatar(message) {
    var props = this.props;
    // if there is no user attached hide the avatar
    if (!message.user && !props.ml.buffer.state.setting('avatars.show_without_user')) {
      return false;
    }

    // if its not a message hide the avatar
    if (!this.isMessage(message)) {
      return false;
    }

    // dont show avatars in server or special buffers
    if (props.ml.buffer.isServer() || props.ml.buffer.isSpecial()) {
      return false;
    }

    // dont show avatar if its a repeat of the same user
    if (this.isRepeat()) {
      return false;
    }
    return true;
  },
  userMode: function userMode(user) {
    var props = this.props;
    return props.ml.buffer.userMode(user);
  },
  userModePrefix: function userModePrefix(user) {
    var props = this.props;
    return props.ml.buffer.userModePrefix(user);
  }
};
var _default = {
  inject: {
    components: {
      default: {
        UserAvatar: _UserAvatar.default,
        MessageInfo: _MessageInfo.default,
        AwayStatusIndicator: _AwayStatusIndicator.default,
        MediaViewer: _MediaViewer.default
      }
    }
  },
  props: {
    ml: Object,
    message: Object,
    idx: Number,
    m: {
      default: function m() {
        // vue uses this function to generate the prop. `this`==null Return our own function
        return function n() {
          // Give our methods some props context before its function is called.
          // This is only safe because the function on the methods object is called on
          // the same js tick
          methods.props = this;
          return methods;
        };
      }
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageModern"]
window._kiwi_exports.components.MessageListMessageModern = exports.default ? exports.default : exports;
